import { Link2 } from 'lucide-react'
import type React from 'react'
import { useTranslation } from 'react-i18next'

import type { LinkedJobContext } from '@/types/timeline'

interface LinkedJobsContextProps {
  context: LinkedJobContext
  variant?: 'tooltip' | 'details'
}

export const LinkedJobsContext: React.FC<LinkedJobsContextProps> = ({
  context,
  variant = 'tooltip',
}) => {
  const { t } = useTranslation()
  const isTooltip = variant === 'tooltip'

  return (
    <div className={isTooltip ? 'space-y-1.5' : 'space-y-2'}>
      <div
        className={`flex items-center gap-1.5 font-semibold ${
          isTooltip ? 'text-white' : 'text-gray-900'
        }`}
      >
        <Link2 size={14} aria-hidden="true" className="shrink-0" />
        <span>{t('linkedJobs.title')}</span>
        <span aria-hidden="true" className={isTooltip ? 'text-slate-400' : 'text-gray-500'}>
          ·
        </span>
        <span className={isTooltip ? 'text-slate-400' : 'text-gray-500'}>
          {t('linkedJobs.summary', { count: context.totalJobs })}
        </span>
      </div>

      <ul className={`space-y-1 ${isTooltip ? 'text-slate-200' : 'text-gray-700'}`}>
        {context.relatedJobs.map((job) => {
          const route =
            [job.fromCode, job.toCode].filter(Boolean).join(' → ') ||
            t('linkedJobs.routeUnavailable')
          const time =
            job.endTime && job.endTime !== job.startTime
              ? `${job.startTime}–${job.endTime}`
              : job.startTime

          return (
            <li key={job.id} className="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-sm">
              <span
                className={`rounded px-1 py-0.5 text-xs font-semibold ${
                  isTooltip ? 'bg-slate-600 text-white' : 'bg-gray-100 text-gray-800'
                }`}
              >
                {job.type}
              </span>
              <span>{route}</span>
              <span className={isTooltip ? 'text-slate-400' : 'text-gray-500'}>{time}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
